import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { NotificationService } from '../../services/notification.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'commonui-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgClass],
})
export class MessageComponent {
  public body: { type: string; msg: string };

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: { type: string; msg: string },
    private notifSrv: NotificationService
  ) {
    this.body = data;
  }

  close(): void {
    this.notifSrv.closeMessage();
  }
}
